import { Bar, BarChart, CartesianGrid, LabelList, ReferenceLine, XAxis, YAxis } from 'recharts';
import { ChartTooltip } from '../ChartTooltip';
import { AlertBarChartLabel } from './AlertBarChartLabel';
import React, { useCallback, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { useItemAlertClick } from '../../../InventoryWidget/useItemAlertClick';
import { useFarmParams } from '../../../InventoryWidget/useFarmParams';
import YAxisComponent from './YAxisComponent';
import { useDashboardTooltip } from '../../../../../hooks';
import { useWeightUnit } from '../../../../../hooks/useGetMetric';
const useStyles = (chartWidth) => makeStyles(() => ({
    chartWrapper: {
        display: 'flex',
        width: chartWidth,
        height: 190,
        '& .recharts-cartesian-axis-tick-value': {
            visibility: 'hidden',
        },
    },
}));
export const AlertBarChart = ({ setItems, data, link, widget }) => {
    const reservedSpaceForItemName = 100;
    const chartWidth = Math.max(data.length * reservedSpaceForItemName, 900);
    const classes = useStyles(chartWidth)();
    const onBarClick = useItemAlertClick();
    const { data: farmParams } = useFarmParams();
    const { openTooltip, closeTooltip } = useDashboardTooltip();
    const weightUnit = useWeightUnit();
    const showTooltip = (e) => openTooltip(tooltipContent(e));
    const tooltipContent = (e) => {
        const { deviation, deviationPerc, rationName, dateTime, driverName, tolerance } = e.payload.data;
        return (React.createElement(ChartTooltip, { data: {
                deviation,
                deviationPerc,
                rationName,
                dateTime,
                driverName,
                tolerance: tolerance || 0,
                farmParams,
            }, weightUnit: weightUnit }));
    };
    const onClick = useCallback(({ data: { id } }) => {
        closeTooltip();
        onBarClick(id, link, widget);
    }, [link, widget]);
    const getCoordinates = useCallback((node) => {
        if (node !== null) {
            const itemParams = node.state.curData.map((item) => {
                const { x, width, name, data: { id }, } = item;
                return {
                    x,
                    id,
                    width,
                    name,
                };
            });
            setItems(itemParams);
        }
    }, [data]);
    useEffect(() => {
        window.dispatchEvent(new Event('resize'));
    }, []);
    return (React.createElement("div", { className: classes.chartWrapper },
        React.createElement(YAxisComponent, null),
        React.createElement(BarChart, { data: data, maxBarSize: reservedSpaceForItemName, barCategoryGap: 10, width: chartWidth, height: 190, margin: {
                top: 5,
                right: 30,
                left: 0,
                bottom: 5,
            } },
            React.createElement(CartesianGrid, { vertical: false }),
            React.createElement(XAxis, null),
            React.createElement(YAxis, { domain: [-20, 20], allowDataOverflow: true, tickCount: 5, label: { value: '%', position: 'insideTopRight' }, hide: true }),
            React.createElement(ReferenceLine, { y: 0, stroke: "#46BC01" }),
            React.createElement(Bar, { dataKey: "data.deviationPerc", ref: getCoordinates, onMouseEnter: showTooltip, onMouseLeave: closeTooltip, onClick: onClick, cursor: "pointer" },
                React.createElement(LabelList, { dataKey: "data", content: React.createElement(AlertBarChartLabel, { link: link, widget: widget }) })))));
};
//# sourceMappingURL=AlertBarChart.js.map